import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { ADMIN_LOGIN_SUCCESS } from './store/actions/actionType';
import App from './App';
import rootReducer from './store/reducers';
import './index.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

const initialState = {};

const store = createStore(
  rootReducer,
  initialState,
  compose(
    applyMiddleware(thunk),
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
);

if (localStorage.user) {
  store.dispatch({
    type: ADMIN_LOGIN_SUCCESS,
    payload: JSON.parse(localStorage.user),
  });

   setTimeout(() => {
     localStorage.removeItem('user');
   }, 3600000);
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
